import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appUploadDialog]',
})
export class UploadDialogDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
